module.exports = __webpack_public_path__ + "img/tpc-web-4.363b7ad8.jpg";